<script>

export default {
  props: {
    campaignOverview: {
      type: Object,
      required: true,
    },
  },
  computed: {
    nextPosts() {
      if (!this.campaignOverview.nextPosts || this.campaignOverview.nextPosts.length === 0) {
        return [];
      }
      return (this.campaignOverview.nextPosts)
          .map(nextPost => {
            nextPost.campaignAgreement = this.getCampaignAgreement(nextPost.campaign_agreement_id)
            return nextPost;
          })
          .sort((a, b) => new Date(a.publish_date) - new Date(b.publish_date))
          .slice(0, 3)
          .reverse()
    },
    lastPost() {
      const lastPost = this.campaignOverview.lastPost;
      if (!lastPost) {
        return null;
      }

      lastPost.campaignAgreement = this.getCampaignAgreement(lastPost.campaign_agreement_id)

      return lastPost;
    },
  },
  methods: {
    getCampaignAgreement(id) {
      return this.campaignOverview.campaign_agreements.find(campaignAgreement => {
        return campaignAgreement._id === id
      })
    }
  },
}
</script>

<template>
  <div class="card flex-fill">
    <div class="card-body">
      <h4 class="card-title mb-5">Roadmap</h4>
      <ul class="verti-timeline list-unstyled" v-if="nextPosts.length > 0 || lastPost">

        <li class="event-list pb-5" v-for="(nextPost, index) in nextPosts" :key="nextPost._id" :class="{'active': index === nextPosts.length -1}">
          <div class="event-timeline-dot">
            <i v-if="index === nextPosts.length -1" class="bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
            <i v-else class="bx bx-right-arrow-circle font-size-18"></i>
          </div>
          <div class="media">
            <div class="mr-3">
              <h5 class="font-size-14">
                {{ nextPost.publish_date | localeTimeString({year: undefined}) }}
                <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                ></i>
              </h5>
            </div>
            <div class="media-body">
              <span v-if="nextPost.campaignAgreement
                          && nextPost.campaignAgreement.influencer_profile
                          && nextPost.campaignAgreement.influencer_profile.social_network_accounts[nextPost.social_network]">
                {{nextPost.campaignAgreement.influencer_profile.social_network_accounts[nextPost.social_network].username}},
              </span>
              {{ nextPost.social_network }} {{ nextPost.post_type | snakeToWords }}
            </div>
          </div>
        </li>

        <li class="event-list" v-if="lastPost">
          <div class="event-timeline-dot">
            <i class="bx bx-right-arrow-circle font-size-18"></i>
          </div>
          <div class="media">
            <div class="mr-3">
              <h5 class="font-size-14">
                {{ lastPost.publish_date | localeTimeString({year: undefined}) }}
                <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                ></i>
              </h5>
            </div>
            <div class="media-body">
              <span v-if="lastPost.campaignAgreement
                          && lastPost.campaignAgreement.influencer_profile
                          && lastPost.campaignAgreement.influencer_profile.social_network_accounts[lastPost.social_network]">
                {{lastPost.campaignAgreement.influencer_profile.social_network_accounts[lastPost.social_network].username}},
              </span>
              {{ lastPost.social_network }} {{ lastPost.post_type | snakeToWords }}
            </div>
          </div>
        </li>

      </ul>
      <div v-else class="">
        <h2 class="text-center text-muted">N/A</h2>
      </div>
    </div>
  </div>
</template>
